import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('twofactor_authentication_has_been_enabled'),
    description: defineMessage('all_done_from_now_on_yo_ogging_into_approvalmax'),
    button: defineMessage('done'),
};
